import React, {memo, useCallback, useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from "react-router-dom";
import RefillSvg from "../../icons/Refill";
import AssessmentIcon from '@mui/icons-material/Assessment';
import SomeSvg from "../../icons/Some";
import MenuDropdown from "../baseComponents/Dropdown/MenuDropdown";
import InfoObject from "./InfoObject";
import WashingSvg from '../../icons/Washing';
import UserSvg from "../../icons/User";
import RoutePalette from '../RoutePalette'
import GeozonePalette from '../GeozonePalette'
import DownloadExcelBtn from '../DownloadExcelBtn/DownloadExcelBtn';
import SaveStatus from '../../UIComponents/SaveStatus';
import {setBlockLeftMenuMobileOpen, setDrawerOpen, setSelectedGeoObjArray} from '../../actions/ui'
import {IconButton} from '@mui/material';
import BigExcelSaver from '../BigExcelSaver/BigExcelSaver';
import RouteWatcher from '../RouteWatcher'
import Filter from "../../UIComponents/Filter/Filter";
import {FilterContext} from "../../UIComponents/Filter/Context";
import Pencil from "../../icons/Pencil";
import Button from "../baseComponents/Button/Button";
import Plus from "../../icons/Plus";
import RepeatSvg from "../../icons/Repeat";
import BasketSvg from "../../icons/BasketSvg";
import CheckSvg from "../../icons/Check";
import CancelSvg from "../../icons/CancelSvg";
import RollUpSvg from "../../icons/RollUpSvg";
import {getCriteria} from "../../shared/helpers/getCriteria";
import {useAbortableLoad} from "../../Hooks";
import {getShortDataTable} from "../../shared/helpers/getShortDataTable";
import {saveExcelFile} from "../../shared/helpers/saveExcelFile";
import './style.css'
import {SimpleDialog} from "../../UIComponents/SimpleDialog/SimpleDialog";

const mapStateToProps = (state) => {
    const {
        api: {
            geoObjs,
            getDataGeozoneIntersections,
        } = {},
        ui: {
            geoObjCriteria,
            selectedGeoObjArray,
            isDrawerOpen,
            dateRangeCriteria,
            rangeStartDate,
            rangeEndDate,
            isLeftMenuMobileOpen,
        } = {},
        service: {
            Api: {
                getGeoObj,
            } = {}
        } = {},
    } = state;
    return {
        getGeoObj,
        geoObjs,
        selectedGeoObjArray,
        isDrawerOpen,
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate,
        isLeftMenuMobileOpen,
        geoObjCriteria,
        getDataGeozoneIntersections
    }
}

const statusClasses = [
    'mantis-bg',
    'sea-bg',
    'gurdsman-bg'
]

const icons = [
    (<SomeSvg/>),
    (<SomeSvg/>),
    (<SomeSvg/>),
    (<RefillSvg/>),
    (<RefillSvg/>),
    (<WashingSvg/>),
    (<WashingSvg/>),
    (<UserSvg/>)
]

const getTypesByData = data => {
    if (!data?.length) return []
    return data?.map(({type}) => type).reduce((arr, item) => {
        if (arr.map(({id}) => id).includes(item.id)) {
            return arr
        } else {
            return [...arr, item]
        }
    }, [])
}

const findFirstDifferentTimezone = (data, needToCheckDifferentTimezones) => {

    if (!needToCheckDifferentTimezones) return

    if (!data || data.length < 2) {
        return null;
    }

    const initialTimezone = data[0].timezone.value;

    return data.find((geoObj, index) => index !== 0 && geoObj.timezone.value !== initialTimezone) || null;
};

export const BlockLeftMain = memo(({className}) => {

    const {
        getGeoObj,
        geoObjs: {data: dataInp = []} = {},
        geoObjs,
        selectedGeoObjArray = [],
        isDrawerOpen,
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate,
        isLeftMenuMobileOpen,
        getDataGeozoneIntersections,
        geoObjCriteria
    } = useSelector(mapStateToProps)

    const history = useHistory();
    const dispatch = useDispatch()

    const [filter, setFilter] = useState('')
    // для фильтрации по типам заводим отдельное состояние !!!
    const [typesFinal, setTypesFinal] = useState([])
    const [print, setPrint] = useState(false)

    const [openDialog, setOpenDialog] = useState(false);

    useEffect(() => {
        if (!geoObjs) getGeoObj();
    }, [])

    const onUpdateTrackers = () => {
        if (!geoObjs?.loading) getGeoObj();
    }

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const isDifferentTimezones = (id) => {
        /* проверить на разные часовые пояса */
        if (needToCheckDifferentTimezones) {

            const filteredArrTrackers = geoObjs.data.filter(geoObj => selectedGeoObjArray.includes(geoObj.id))
            const newSelectedObjectTimezone = geoObjs.data.find(geoObj => geoObj.id === id)?.timezone?.value

            if (filteredArrTrackers.length && newSelectedObjectTimezone) {
                const foundedDifferentTimezone = filteredArrTrackers.find(filteredObj => filteredObj.timezone.value !== newSelectedObjectTimezone)

                if (foundedDifferentTimezone) {
                    setOpenDialog(true)
                    return true
                }
            }
        }
        return false
    }

    const actionCheckBox = (id) => {

        if (isDifferentTimezones(id))   return

        if (selectedGeoObjArray.includes(id)) {
            dispatch(setSelectedGeoObjArray(selectedGeoObjArray.filter((item) => id !== item)))
        } else {
            dispatch(setSelectedGeoObjArray([...selectedGeoObjArray, id]))
        }
    }
    const navibateGroupReport = () => {
        if (selectedGeoObjArray.length) {
            history.push('/doc');
        }
    }

    useEffect(() => {
        if (!dataInp?.length) return
        /* первоначальная подгрузка типов геообъектов !!! */
        setTypesFinal(getTypesByData(dataInp))
    }, [dataInp?.length])

    const handleFilterInput = (value) => {
        setFilter(value)
    }

    const data = useMemo(() => {
        return filter === '' ?
            dataInp :
            dataInp.filter(({name}) => (name.indexOf(filter) !== -1));
    }, [dataInp?.length, filter])

    const types = useMemo(() => {
        if (!data?.length) return []
        return (getTypesByData(data))
    }, [data?.length])

    const needToCheckDifferentTimezones = useMemo(() => {
        return geoObjCriteria === "2" && getDataGeozoneIntersections?.data && selectedGeoObjArray.length
    }, [geoObjCriteria, getDataGeozoneIntersections?.data?.length, selectedGeoObjArray?.length])

    const handleSelectAll = (groupId) => {
        const groupAveilableId = data.filter((item) => item?.type?.id === groupId).map(({id}) => id)
        const groupSelectedId = selectedGeoObjArray.filter((item) => groupAveilableId.includes(item))
        const unselectedItems = selectedGeoObjArray.filter((item) => !groupAveilableId.includes(item))
        if (groupSelectedId.length === groupAveilableId.length) {

            // сброс выделения !!!
            dispatch(setSelectedGeoObjArray([...unselectedItems]))

        } else {

            // все объекты выделены !!!
            const differentTimezoneObj = findFirstDifferentTimezone(geoObjs.data, needToCheckDifferentTimezones);

            if (differentTimezoneObj) {
                setOpenDialog(true)
            } else {
                setOpenDialog(false)
                dispatch(setSelectedGeoObjArray([...unselectedItems, ...groupAveilableId]))
            }
        }
    }

    const resetAllGeoObjects = () => {
        if (selectedGeoObjArray?.length && geoObjCriteria === "2") {
            dispatch(setSelectedGeoObjArray([]))
        }
    }

    useEffect(() => {

        if (!geoObjs?.data?.length) return

        const filteredGeoObjects = geoObjs?.data?.filter(obj => selectedGeoObjArray.includes(obj.id))
        const differentTimezoneObj = findFirstDifferentTimezone(filteredGeoObjects, needToCheckDifferentTimezones);

        if (differentTimezoneObj) {
             resetAllGeoObjects()
        }

    }, [selectedGeoObjArray?.length, geoObjCriteria, geoObjs?.data?.length, needToCheckDifferentTimezones])

    const onSelectGeoObjectChange = (value) => {
        if (!value || !value?.length) {
            setTypesFinal(types)
        } else {
            setTypesFinal(types.filter(el => value.includes(el.name)))
        }
    }

    const selectGeoObjectValues = useMemo(() => types.map(el => el.name), [types?.length])

    const FilterContextValues = {
        selectGeoObjectValues,
        onSelectGeoObjectChange,
        onSelectTwoChange: () => {},
        onFilterChange: handleFilterInput
    }

    const toggleDrawer = () => {
        // если мобильная верстка - закрыть мобильное меню
        if (isLeftMenuMobileOpen) {
            dispatch(setBlockLeftMenuMobileOpen(false))
        } else {
            // иначе свернуть drawer компонент
            dispatch(setDrawerOpen(!isDrawerOpen))
        }
    }

    const criteria = getCriteria(
        dateRangeCriteria,
        rangeStartDate,
        rangeEndDate
    )

    const workingTimeSheet = useAbortableLoad(
        'getWorkingTimeSheet',
        'workingTimeSheet',
        {
            objIds: selectedGeoObjArray,
            criteria
        },
        selectedGeoObjArray?.length === 1 && print,
        [selectedGeoObjArray, print, dateRangeCriteria, rangeStartDate, rangeEndDate],
        'setWorkingTimeSheet'
    )

    const printReport = useCallback(() => {
        setPrint(true)
    }, [])

    useEffect(() => {
        if (!workingTimeSheet?.data || !workingTimeSheet?.data?.length || !print) return

        const dataTable = getShortDataTable(workingTimeSheet?.data)
        saveExcelFile({
            data: dataTable,
            name: `Краткий табель_${(new Date()).toDateString()}`,
            description: 'Отчет'
        })
        setPrint(false)
    }, [workingTimeSheet?.data?.length, print])

    return (
        <div className={`menu ${className}`}>
            <SaveStatus title="Загрузка списка трекеров" dataObj={geoObjs} successShowTime={100}/>
            <BigExcelSaver/>
            <RouteWatcher/>

            {typesFinal?.length ? (
                <FilterContext.Provider value={FilterContextValues}>
                    <Filter/>
                </FilterContext.Provider>
            ) : null}

            <div className="menu__actions  main-border-bottom">
                <div className="menu__actions-wrap">
                    <div className={"leftpart-actions"}>
                        <Button className="menu-actions-btn" children={<CheckSvg/>}/>
                        <Button className="menu-actions-btn" children={<Plus/>}/>
                        <Button className="menu-actions-btn" children={<Pencil/>}/>
                        <Button className="menu-actions-btn" children={<BasketSvg/>}/>
                        <Button className="menu-actions-btn" onClick={onUpdateTrackers} children={<RepeatSvg/>}/>
                        <Button className="menu-actions-btn" children={<CancelSvg/>}/>
                    </div>
                    {/*<Button children={<PauseSvg/>}/>
                    <Button className="strokewidth3" children={<MultiplySvg/>}/>
                    <Button children={<CastleSvg/>}/>*/}

                    <div className={"rightpart-actions"}>
                        <IconButton color="mainButton" disabled={!selectedGeoObjArray.length}
                                    onClick={navibateGroupReport}><AssessmentIcon/></IconButton>
                        <DownloadExcelBtn/>
                        <Button
                            className={"toggleDrawerBtn"}
                            onClick={toggleDrawer}
                            title={'Закрыть панель'}
                        >
                            <RollUpSvg/>
                        </Button>
                    </div>

                </div>
            </div>
            <div className={"list-block"}>
                {typesFinal && typesFinal.map(({id: tId, name: tName}) => {
                    const items = data.filter(({type: {id}}) => id === tId)
                    return (
                        <MenuDropdown id={tId} title={tName} total={items.length} key={tId} open
                                      onSelectAll={handleSelectAll}>
                            {items.map(({id, name, icon, status}, i) => {
                                return (
                                    <InfoObject
                                        actionCheckBox={actionCheckBox}
                                        bgColorClass={statusClasses[parseInt(status)]}
                                        title={name}
                                        svg={icons[parseInt(icon)]}
                                        key={id}
                                        key_item={id}
                                        printReport={printReport}
                                    />
                                )
                            })}
                        </MenuDropdown>
                    )
                })}
                <GeozonePalette/>
                <RoutePalette/>
            </div>

            <SimpleDialog
                onClose={handleCloseDialog}
                title={'Ошибка добавления трекера'}
                text={'Трекер принадлежит другой часовой зоне и не может быть добавлен в группу'}
                open={openDialog}
            />

        </div>
    )
})